import { lazy, Suspense } from "react";
import "./styles/global.css";
import "./styles/toastr.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import ProtectedRoute from "./components/ProtectedRoute";
import MainLayout from "./components/Mainlayout";
import SignInPage from "./pages/sign-in/page";

const ProductFinder = lazy(
  () => import("./pages/product-finder/components/ProductFinder"),
);
const ProductGallery = lazy(
  () => import("./pages/product-finder/components/ImageSections"),
);
const ProductDetailPage = lazy(() => import("./pages/product-detail/page"));
const DataSheet = lazy(
  () => import("./pages/product-detail/components/DataSheet"),
);
const FlipbookPage = lazy(() => import("./pages/flipbook/page"));

const PageFallback = () => (
  <div className="flex justify-center items-center min-h-[50vh] bg-black">
    <div className="text-white">Loading...</div>
  </div>
);

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Suspense fallback={<PageFallback />}>
          <Routes>
            <Route path="/sign-in" element={<SignInPage />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<MainLayout />}>
                <Route path="/product-finder" element={<ProductFinder />} />
                <Route path="/product-gallery" element={<ProductGallery />} />
                <Route path="/product-detail" element={<ProductDetailPage />} />
                <Route path="/sheet/:id" element={<DataSheet />} />
                <Route path="/flipbook" element={<FlipbookPage />} />
              </Route>
            </Route>
            <Route path="/" element={<Navigate to="/sign-in" replace />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
